import {createReducer, on} from '@ngrx/store';
import {StateStatus} from "../../models/state-status.models";
import {getUsersRoleAndTenantDataSuccess} from "./auth.action";
import {TenantRole} from "../../models/tenant-role.model";

export interface AuthState {
  tenantRole: TenantRole | null
  error: string | null;
  status: StateStatus;
}

export const initialState: AuthState = {
  tenantRole: null,
  error: null,
  status: 'pending' as StateStatus,
};

export const authReducer = createReducer(
  initialState,
  on(getUsersRoleAndTenantDataSuccess, (state, { tenantRoleData }) => ({
    ...state,
    tenantRole: tenantRoleData,
    status: 'loadSuccess' as StateStatus,
  })),
);



